module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/view/traitementmasse/traitementmasse.component.css
// module id = ./src/app/view/traitementmasse/traitementmasse.component.css
// module chunks = main